import React from "react";

import { IconClose } from "@synthesis/shared-icons";
import { Button, Select } from "@synthesis/shared-ui";

import { useUsersByGroupQuery } from "../hooks/use-experts-queries";
import type { RoleItemProps } from "../list-of-experts-page.lib";

export const RoleItem = ({ onSelect, id, onDeleteRole, isGroupsLoading, getRoleDisplay, selectGroupsValues }: RoleItemProps) => {
  const [groupId, setGroupId] = React.useState<string | null>(null);
  const [userId, setUserId] = React.useState<string | null>(null);
  const [value, setValue] = React.useState<string | null>(null);
  const [isMembersLoading, usersByGroup] = useUsersByGroupQuery(groupId);

  const usersValues = React.useMemo(() => {
    const values: { value: string; label: string }[] = [];
    usersByGroup.forEach((user) => {
      if (user.id) {
        values.push({
          value: user.id,
          label: `${user.lastName ?? ""} ${user.firstName ?? ""} ${user.middleName ?? ""}`.trim(),
        });
      }
    });
    return values;
  }, [usersByGroup]);

  const user = React.useMemo(() => {
    return usersByGroup.find((u) => u.id === userId);
  }, [usersByGroup, userId]);

  const onSelectGroup = (selectedId: string) => {
    setValue(null);
    setGroupId(selectedId);
    onSelect({ id, userId: null });
  };

  const onSelectUser = (selectedId: string) => {
    setValue(selectedId);
    onSelect({ id, userId: selectedId });
    setUserId(selectedId);
  };

  const handleDelete = () => {
    onDeleteRole(id);
  };

  return (
    <div className="not-last:border-b grid grid-cols-[1fr_1.5fr_1fr_1fr]">
      <div className="flex w-56 grow items-center justify-start px-4 py-6">
        <Select
          className="min-w-56"
          isSearch={false}
          placeholder="Выберите из списка"
          size="md"
          isLoading={isGroupsLoading}
          value={groupId ?? ""}
          items={selectGroupsValues}
          onChange={onSelectGroup}
        />
      </div>
      <div className="flex w-56 grow items-center justify-start px-4 py-6">
        <Select
          className="min-w-56"
          isSearch={false}
          placeholder="Выберите из списка"
          size="md"
          isLoading={Boolean(isMembersLoading)}
          value={value ?? ""}
          items={usersValues}
          onChange={onSelectUser}
        />
      </div>
      <div className="flex grow items-center justify-start px-4 py-6">{getRoleDisplay(user)}</div>
      <div className="flex grow items-center justify-start px-4 py-6">
        <Button size="sm" onClick={handleDelete} leftIcon={<IconClose className="size-5" />}>
          Отменить
        </Button>
      </div>
    </div>
  );
};
